import { render, staticRenderFns } from "./DocumentsArea.vue?vue&type=template&id=e093f834&"
import script from "./DocumentsArea.vue?vue&type=script&lang=ts&"
export * from "./DocumentsArea.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsArea.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports